import setCalendarLeftPaneWidth from './setCalendarLeftPaneWidth';
import { CalendarLayoutLeftPaneConstants } from '../constants';
import getLeftPaneMinWidth from '../selectors/getLeftPaneMinWidth';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Calculates and sets the current calendars list width. Note that this is returning the width of the
 * calendars pane / list component, which is just one part of the full left nav component.
 * @returns the number of pixels
 */
export function calculateCalendarsListPaneWidth(): number {
    let viewStateConfiguration = getUserConfiguration().ViewStateConfiguration;

    let newNavigationBarWidth;
    let savedNavigationBarWidth = viewStateConfiguration.CalendarSidePanelWidth;
    if (savedNavigationBarWidth < getLeftPaneMinWidth()) {
        // Fallback to default navigation bar width when expanded folder pane width is smaller than threshold.
        // This is the safe-guard logic if other client has smaller leftPaneMinWidth
        newNavigationBarWidth = CalendarLayoutLeftPaneConstants.leftPaneDefaultWidth;
    } else if (savedNavigationBarWidth > CalendarLayoutLeftPaneConstants.leftPaneMaxWidth) {
        // Fallback to leftPaneMaxWidth if it's beyond the range
        newNavigationBarWidth = CalendarLayoutLeftPaneConstants.leftPaneMaxWidth;
    } else {
        // Return savedNavigationBarWidth if it's within the range
        newNavigationBarWidth = savedNavigationBarWidth;
    }

    // Update the UserOptions.NavigationBarWidth
    setCalendarLeftPaneWidth(newNavigationBarWidth);

    return newNavigationBarWidth;
}
